import React, { Suspense } from "react";
// Only these two get lazy‑loaded:
const VendorDashboard = React.lazy(() =>
  import("@/modules/vendor/pages/Dashboard/Dashboard")
);
const ChatContainer = React.lazy(() =>
  import("@/modules/vendor/pages/ChatInbox")
);
import LoanApplications from "@/modules/vendor/LoanApplications";
import Settings from "@/modules/vendor/pages/Settings/Settings";
import ProfileWizard from "@/modules/vendor/ProfileWizard/index";
import ProtectedRoute from "./ProtectedRoute";
import VendorChatInbox from "@/modules/vendor/pages/ChatInbox";
import MainLayout from "@/layouts/MainLayout";
import UploadProfileImage from "@/modules/vendor/pages/UploadProfilePicture";
import OnboardingLayout from "@/layouts/OnBoardingLayout";
import Loader from "@/components/Loader";
import ShimmerChatLoader from "@/components/Skeleton/ChatMessageShimmer";

const vendorRoutes = [
  // Vendor routes using MainLayout
  {
    path: "/vendor",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loader />}>
            <VendorDashboard />
          </Suspense>
        ),
      },
      {
        path: "inbox",
        element: (
          <Suspense fallback={<Loader />}>
            <ChatContainer />
          </Suspense>
        ),
      },
      { path: "inbox/:customerId", element: <VendorChatInbox /> },
      { path: "loan-applications", element: <LoanApplications /> },
      { path: "settings", element: <Settings /> },
    ],
  },
  {
    path: "/vendor/onboarding",
    element: (
      <ProtectedRoute>
        <OnboardingLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "upload-profile-image", element: <UploadProfileImage /> },
      { path: "profile-wizard", element: <ProfileWizard /> },
    ],
  },
];

export default vendorRoutes;
